import React from "react";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { greyScaleColour } from "@tphglobal/common/theme/style.palette";
import { fontSize } from "@tphglobal/common/theme/style.typography";
import { StyledTableCell } from "../styles";

interface ReorderDragHandleCellProps {
  visible: boolean;
}

const ReorderDragHandleCell: React.FC<ReorderDragHandleCellProps> = ({
  visible,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <StyledTableCell width="25px">
      <DragIndicatorIcon
        style={{
          height: fontSize?.b1,
          width: fontSize?.b1,
          color: greyScaleColour?.grey90,
          cursor: "grab",
        }}
      />
    </StyledTableCell>
  );
};

export default ReorderDragHandleCell;
